module.exports = __webpack_public_path__ + "static/media/qrCodeOversea.5b7e75f1.svg";